import { ADD_TEAMS } from "../constants/teamConstants";

const teamReducer = (state = [], action) => {
  switch (action.type) {
    case ADD_TEAMS:
      if (Array.isArray(action.payload)) {
        return [...state, ...action.payload];
      } else {
        return [...state, action.payload];
      }
    default:
      return state;
  }
};

export default teamReducer;
